module.exports = __webpack_public_path__ + "img/mdi_format-list-group.d3e100a4.svg";